import { memo } from 'react';
import Script from 'next/script';
import { AnalyticsPixelId } from 'core/analytics/entities';
import { TaboolaScriptsService } from 'core/analytics/services';
import { CustomAppEvents } from 'core/common/entities';
import { areArraysOfPrimitivesEqual } from 'core/common/utils/areArraysOfPrimitivesEqual';
import { prepareHtml } from 'core/common/utils/prepareHtml';

type TaboolaScriptsProps = {
  ids: Array<AnalyticsPixelId>;
};

const TaboolaScripts = ({ ids }: TaboolaScriptsProps) => {
  return (
    <>
      {ids.map((id: string) => {
        return (
          <Script
            id={`taboola-pixel-${id}`}
            key={`taboola-pixel-${id}`}
            strategy="afterInteractive"
            dangerouslySetInnerHTML={prepareHtml(TaboolaScriptsService.getPixelCode(id))}
            onReady={() => {
              try {
                const event = new Event(CustomAppEvents.TABOOLA_PIXEL_LOADED);
                document.dispatchEvent(event);
              } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error dispatching Taboola pixel loaded event', error);
              }
            }}
          />
        );
      })}
    </>
  );
};

export default memo(TaboolaScripts, (prevProps, nextProps) =>
  areArraysOfPrimitivesEqual(prevProps.ids, nextProps.ids),
);
